import styled from 'styled-components';
import withProps from '../utils/withProps';

const getFontSize = props => {
  if (props.xs) {
    return '1em';
  } else if (props.s) {
    return '1.2em';
  } else if (props.m) {
    return '1.5em';
  } else if (props.l) {
    return '2em';
  } else if (props.xl) {
    return '3em';
  } else {
    return '1em';
  }
};

export default withProps({ className: 'material-icons' })(styled.i`
  color: ${props => props.theme.textColor.toHex()};
  font-size: ${getFontSize};
  cursor: pointer;
`);
